import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useDocumentationArea } from "./useDocumentationArea";
import { useDependencies } from "./useDependencies";

export const usePatchDocumentationAreaLocale = () => {
  const { documentationAreaController } = useDependencies();
  const { documentationArea } = useDocumentationArea();
  const documentationAreaId = documentationArea?.getId();
  const queryClient = useQueryClient();

  const { token } = useAuth();

  const mutationFn = async (locale: string) => {
    if (!documentationArea) return;
    await documentationAreaController.patchLocale(
      token,
      documentationArea.getId(),
      documentationArea.getActor().getId(),
      locale,
    );
  };

  const { isPending, mutate } = useMutation({
    mutationKey: ["session-locale"],
    mutationFn,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["DocumentationArea", documentationAreaId] });
      queryClient.invalidateQueries({ queryKey: ["translations"] });
    },
  });

  return { isLoading: isPending, mutate };
};
